import defaultImage from "../assets/others/chatapp.png";

export const defaultChatBotSettings = {
    title: 'DemoBot',
    subTitle: 'Built using Botcircuits',
    welcomeMessage: 'Hi there. How can I help you?',
    tips: [],
    inputPlaceHolder: 'Type a message...',
    logo: defaultImage,
    headerBackgroundColor: '#6366f1',
    headerTextColor: "#f9fafb",
    chatWindowBackgroundColor: "#f9fafb",
    sendBarBackgroundColor: '#e2e8f0',
    intentLess: true
}